var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 406,
    height: 244,
    viewBox: "0 0 406 244",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2425_595)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2425_595",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -1,
    width: 407,
    height: 245
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M406.5 -0.5H0.5V243.5H406.5V-0.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2425_595)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224.5 21.6C180.8 35.6 42.5 -33.4 53.3 60.9C55 74.9 64 94.7 56.4 107.8C50.9 117.6 40.8 123.3 31.1 127.2C5.60002 137.6 -3.79998 157.1 2.60002 184.9C19.8 259.9 113.7 242.1 163 219.9C198 203.4 239.4 200.5 275.7 214.5C304.1 225.9 321.8 249.8 355.2 242.8C384.8 236.8 389.3 208.8 380.6 182.7C375.7 166.5 372.2 159.7 381.9 144.1C390.1 128.6 404.5 116.9 405.7 98.7C405.9 79 397 59.2 379.5 51.8C365.3 45.7 352.4 48.2 338.3 44.4C307 35.6 286.8 -13.3 248 3.49996C238.3 8.09996 232.9 18.7 222.3 21.8",
    fill: "#2F32FE",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.9 132.7C151.1 132.7 154.2 129.9 154 126.5C153.9 123.2 151.3 120.3 147.9 120.3C144.5 120.3 141.6 123.1 141.8 126.5C141.8 129.8 144.5 132.7 147.9 132.7Z",
    fill: "#2F32FE",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.4 132.7C261.6 132.7 264.7 129.9 264.5 126.5C264.4 123.2 261.8 120.3 258.4 120.3C255 120.3 252.1 123.1 252.3 126.5C252.3 129.8 255 132.7 258.4 132.7Z",
    fill: "#2F32FE",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.1 219.5H112.9C111.3 219.5 104.8 219.3 98.5002 218.6C94.8002 218.3 92.0002 217.8 89.9002 217.3C88.8002 217 87.8002 216.7 87.1002 216.4C86.9002 216.3 86.8002 216.2 86.7002 216.2C86.5002 216.2 86.4002 216 86.3002 215.9H86.2002V215.2L108 182.6V182.2C108 178.9 110.1 176.3 112.7 176.3H293.1C295.7 176.3 297.8 178.9 297.8 182.2C298.9 183.9 312.4 204.4 319.6 215.2L319.8 215.5L319.4 215.9C319.3 216 319 216.3 318.6 216.4C318 216.7 317.1 217 315.9 217.3C313.2 217.9 310.2 218.3 307.3 218.6C301.1 219.2 294.4 219.5 293 219.5H293.1ZM87.4002 215.3C87.4002 215.3 87.5002 215.3 87.6002 215.5C88.2002 215.7 89.1002 216 90.2002 216.3C92.2002 216.8 94.9002 217.2 98.6002 217.6C105.3 218.3 111.9 218.5 112.9 218.5H293.1C294.5 218.5 301.2 218.2 307.4 217.6C310.2 217.3 313.2 216.9 315.8 216.3C316.9 216 317.8 215.7 318.4 215.4C318.5 215.4 318.6 215.4 318.7 215.3C304.234 193.433 297 182.433 297 182.3V182.1C297 179.4 295.3 177.2 293.3 177.2H112.8C110.8 177.2 109.1 179.4 109.1 182.1L109.3 182.4L87.4002 215.3Z",
    fill: "#2F32FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166 207.8H119.6L127.7 188.1H169.6L165.9 207.8H166Z",
    fill: "#2F32FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.2 207.8H286.6L278.5 188.1H236.6L240.3 207.8H240.2Z",
    fill: "#2F32FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.8 207.8H308.1L294.7 188.1H282.4L291.8 207.8Z",
    fill: "#2F32FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.5 207.8H98.2002L111.6 188.1H123.9L114.6 207.8H114.5Z",
    fill: "#2F32FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.2 207.8H170.2L173.9 188.1H232.6L236.3 207.8H236.2Z",
    fill: "#2F32FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.1 58.1999C205.6 58.1999 205.6 54.2999 203.1 54.2999C200.6 54.2999 200.6 58.1999 203.1 58.1999Z",
    fill: "#2F32FE",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.9 119.4C164.5 119.4 164.1 119.2 163.7 118.9C163.1 118.3 163.1 117.2 163.7 116.6L177.6 102.7C178.2 102.1 179.3 102.1 179.9 102.7C180.5 103.3 180.5 104.4 179.9 105L166 118.9C165.7 119.2 165.3 119.4 164.8 119.4H164.9Z",
    fill: "#2F32FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.8 119.5C178.4 119.5 178 119.3 177.6 119L163.7 105.1C163.1 104.5 163.1 103.4 163.7 102.8C164.3 102.2 165.4 102.2 166 102.8L179.9 116.7C180.5 117.3 180.5 118.4 179.9 119C179.6 119.3 179.2 119.5 178.7 119.5H178.8Z",
    fill: "#2F32FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.5 119.4C227.1 119.4 226.7 119.2 226.3 118.9C225.7 118.3 225.7 117.2 226.3 116.6L240.2 102.7C240.8 102.1 241.9 102.1 242.5 102.7C243.1 103.3 243.1 104.4 242.5 105L228.6 118.9C228.3 119.2 227.9 119.4 227.4 119.4H227.5Z",
    fill: "#2F32FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.4 119.5C241 119.5 240.6 119.3 240.2 119L226.3 105.1C225.7 104.5 225.7 103.4 226.3 102.8C226.9 102.2 228 102.2 228.6 102.8L242.5 116.7C243.1 117.3 243.1 118.4 242.5 119C242.2 119.3 241.8 119.5 241.3 119.5H241.4Z",
    fill: "#2F32FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.8 144.2C178.4 144.2 178 144.1 177.7 143.8C177 143.2 177 142.1 177.7 141.5C180.1 138.9 189.1 130.4 203.2 130.4H203.4C217.2 130.4 226.2 138.9 228.6 141.5C229.2 142.2 229.2 143.2 228.6 143.8C227.9 144.4 226.9 144.4 226.3 143.8C224.1 141.5 216 133.8 203.5 133.7C203.5 133.7 203.4 133.7 203.3 133.7C190.6 133.7 182.4 141.4 180.2 143.8C179.9 144.1 179.4 144.3 179 144.3L178.8 144.2Z",
    fill: "#2F32FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.2 227.6H88.1C87.4 227.6 86.9 227.5 86.5 227.2C86.1 227 85.8 226.6 85.6 226.3C85.2 225.6 85 224.6 85 222.9V218.8C85 217.1 85.2 216.1 85.6 215.5C85.8 215 86.1 214.7 86.6 214.5C86.9 214.3 87.5 214.1 88.1 214.1H318.1C318.8 214.1 319.3 214.2 319.7 214.5C320.1 214.7 320.4 215.1 320.6 215.4C321 216.1 321.2 217.1 321.2 218.8V222.9C321.2 224.6 321.2 225.6 320.7 226.2C320.5 226.7 320.2 227 319.7 227.2C319.4 227.4 318.8 227.6 318.2 227.6ZM88.1 215.1C87.7 215.1 87.3 215.1 87.1 215.3C86.7 215.5 86.6 215.6 86.5 215.9C86.1 216.6 86.1 217.8 86.1 218.8V222.9C86.1 223.9 86.1 225.1 86.5 225.8C86.6 226 86.9 226.3 87.1 226.4C87.3 226.5 87.6 226.6 88.1 226.6H318.2C318.6 226.6 319 226.6 319.2 226.4C319.6 226.2 319.7 226.1 319.8 225.8C320.1 225.2 320.2 224.3 320.2 223.4V218.8C320.2 217.8 320.2 216.6 319.8 215.9C319.7 215.7 319.4 215.4 319.2 215.3C319 215.2 318.7 215.1 318.2 215.1H88.1Z",
    fill: "#2F32FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.7 223.5H162.4C161 223.5 159.9 222.4 159.9 221C159.9 219.6 161 218.5 162.4 218.5H243.7C245.1 218.5 246.2 219.6 246.2 221C246.2 222.4 245.1 223.5 243.7 223.5ZM162.4 219.5C161.6 219.5 160.9 220.2 160.9 221C160.9 221.8 161.6 222.5 162.4 222.5H243.7C244.5 222.5 245.2 221.8 245.2 221C245.2 220.2 244.5 219.5 243.7 219.5H162.4Z",
    fill: "#2F32FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.7 182.3H110.6C108 182.3 105.9 180.2 105.9 177.6V56.4C105.9 53.8 108 51.7 110.6 51.7H295.7C298.3 51.7 300.4 53.8 300.4 56.4V177.6C300.4 180.2 298.3 182.3 295.7 182.3ZM110.6 52.7C108.6 52.7 106.9 54.4 106.9 56.4V177.6C106.9 179.6 108.6 181.3 110.6 181.3H295.7C297.7 181.3 299.4 179.6 299.4 177.6V56.4C299.4 54.4 297.7 52.7 295.7 52.7H110.6Z",
    fill: "#2F32FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.8 35.5V76.2C268.8 80.2 274.9 80.2 274.9 76.2V35.5C274.9 31.5 268.8 31.5 268.8 35.5Z",
    fill: "#EEB728"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.9 91.9C274.3 91.9 276.6 89.8 276.5 87.3C276.4 84.8 274.5 82.7 271.9 82.7C269.3 82.7 267.2 84.8 267.3 87.3C267.4 89.8 269.3 91.9 271.9 91.9Z",
    fill: "#EEB728"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2425_595"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 406,
    height: 244,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorLight);
export default __webpack_public_path__ + "static/media/error-light.3be8e162.svg";
export { ForwardRef as ReactComponent };